export default __webpack_public_path__ + "static/media/privacy.5056da29.md";